import { render, staticRenderFns } from "./StockDispatchListItem.vue?vue&type=template&id=86232c6c&"
import script from "./StockDispatchListItem.vue?vue&type=script&lang=js&"
export * from "./StockDispatchListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StockDispatchListItem.vue"
export default component.exports